import React from "react";
import { useSelector } from "react-redux";

import { i18, trb } from "@utilities";
import { InputFormField, SelectFormField } from "@components/FormField/HookFormFields";
import { FullWidthInputWrapper } from "@components";
import { selectAvailableCountryOptions, selectBasicBusinessOptions } from "@redux";

export const BusinessPartner = ({ control, businessIndex }) => {
  const availableCountries = useSelector(selectAvailableCountryOptions);
  const businessOptions = useSelector(selectBasicBusinessOptions);

  return (
    <>
      {/* neccessary for form value */}
      <InputFormField
        control={control}
        name={`clientBusPartner.${businessIndex}.cientBusPartnerType`}
        defaultValue={businessIndex === 0 ? "S.121" : `CBP${businessIndex + 1}`}
        className="d-none"
      />

      <FullWidthInputWrapper>
        <InputFormField
          control={control}
          name={`clientBusPartner.${businessIndex}.data.clientBusPartnerName`}
          title={trb(i18.Labels.ClientBusPartnerName)}
        />
      </FullWidthInputWrapper>

      <FullWidthInputWrapper>
        <SelectFormField
          control={control}
          name={`clientBusPartner.${businessIndex}.data.clientBusPartnerAct`}
          title={trb(i18.Labels.ClientBusPartnerAct)}
          options={businessOptions}
          optionsLabel="label"
          optionsValue="value"
          isSearchable
        />
      </FullWidthInputWrapper>

      <FullWidthInputWrapper>
        <SelectFormField
          control={control}
          name={`clientBusPartner.${businessIndex}.data.clientBusPartnerCountry`}
          title={trb(i18.Labels.ClientBusPartnerCountry)}
          options={availableCountries}
          optionsLabel="label"
          optionsValue="value"
          isSearchable
          defaultValue="LT"
        />
      </FullWidthInputWrapper>
    </>
  );
};
